'use client'

import Image from 'next/image'
import { DefaultCellComponentProps } from 'payload'
import React from 'react'
import { Play } from 'lucide-react'

export const PropertyTitleCell: React.FC<DefaultCellComponentProps> = ({ rowData }) => {
  const firstImage = rowData.mediaSection?.images?.[0]?.image
  const firstVideo = rowData.mediaSection?.videos?.[0]?.video

  // Show image if it exists, otherwise show video placeholder
  const showImage = !!firstImage
  const imageDisplayed = firstImage?.url || '/placeholder.jpg'

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '8px 0',
      }}
    >
      {/* Media Thumbnail */}
      <div
        style={{
          position: 'relative',
          width: '72px',
          height: '72px',
          borderRadius: '10px',
          overflow: 'hidden',
          backgroundColor: '#f2f2f2',
        }}
      >
        {showImage ? (
          <Image
            src={imageDisplayed}
            alt={rowData.title}
            width={72}
            height={72}
            style={{
              width: '72px',
              height: '72px',
              objectFit: 'cover',
            }}
          />
        ) : firstVideo ? (
          // Video placeholder
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#000',
              color: '#fff',
            }}
          >
            <Play size={28} />
          </div>
        ) : (
          // Fallback
          <div
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: '#eee',
            }}
          />
        )}
      </div>

      {/* Text Info */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 600 }}>{rowData.title}</span>
        <span style={{ fontSize: '12px', color: '#7A7A7A' }}>
          {rowData.locationSection?.address}
        </span>
        {rowData.propertyDescription?.price && (
          <span style={{ marginTop: '4px' }}>
            <strong style={{ fontWeight: 700 }}>
              DZD {rowData.propertyDescription.price.toLocaleString()}
            </strong>
          </span>
        )}
      </div>
    </div>
  )
}
